// extracted by mini-css-extract-plugin
module.exports = {"home":"studio_home__3erCB","ant-spin-nested-loading":"studio_ant-spin-nested-loading__35lp9"};